import {
  FETCH_ALERT_SETTINGS_REQUEST,
  FETCH_ALERT_SETTINGS_SUCCESS,
  FETCH_ALERT_SETTINGS_FAILURE,
  UPDATE_ALERT_SETTINGS_REQUEST,
  UPDATE_ALERT_SETTINGS_SUCCESS,
  UPDATE_ALERT_SETTINGS_FAILURE
} from '../actions/alertSettingsActions';

const initialState = {
  settings: [],
  loading: false,
  saving: false,
  error: null
};

const alertSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALERT_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ALERT_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload };
    case FETCH_ALERT_SETTINGS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_ALERT_SETTINGS_REQUEST:
      return { ...state, saving: true, error: null };
    case UPDATE_ALERT_SETTINGS_SUCCESS:
      return { ...state, saving: false, settings: action.payload };
    case UPDATE_ALERT_SETTINGS_FAILURE:
      return { ...state, saving: false, error: action.payload };
    default:
      return state;
  }
};

export default alertSettingsReducer;
